// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__e94nE","slider":"Switch_slider__hoG2D"};